import service from '@/store/services/municipios-service';

const state = {
  list: {},
  municipio: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, municipio) => {
    state.municipio = municipio;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((municipio) => { commit('SET_RESOURCE', municipio); });
  },

  baixarArquivo({ commit, dispatch }, params) {
    // Chama a função do serviço para baixar o PDF
      return service.downloadPDF(params[0],params[1])
        .then((resposta) => {
          // Manipular a resposta, se necessário
          //console.log("PDF baixado com sucesso!", resposta);
          return resposta;
        })
        .catch((erro) => {
          // Lidar com erros, como usuário não autenticado
          console.error("Erro ao baixar a apólice:", erro);
          throw erro;
        });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((municipio) => { commit('SET_RESOURCE', municipio); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((municipio) => { commit('SET_RESOURCE', municipio); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  municipio: state => state.municipio,
  dropdown: (state) => {
    return state.list.map(municipio => ({
      id: municipio.id,
      name: municipio.name + " - " + municipio.uf,
      uf: municipio.uf
    }));
  }
};

const municipios = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default municipios;
